import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { onlyNumberRegexp } from 'lib/regexp/regexpConst';

import Modal from 'components/organisms/NewModal';
import NewInput from 'components/atoms/NewInput';

const GroupModal = (props) => {
  const { modal, handleModalClose, groupName, getModal, handleSubmit } = props;
  const { type } = modal;
  const { t } = useTranslation();
  const [error, setError] = useState({
    grpName: { flag: false, message: null },
    grpSortNo: { flag: false, message: null },
    userIds: { flag: false, message: null },
  });

  const handleGetParams = (newParam, name) => {
    let newParams = { ...newParam };
    if (!newParams[name]) {
      delete newParams[name];
    }
    handleValidation(newParams);
    getModal({
      ...modal,
      params: newParams,
    });
  };

  const handleValidation = (newParams) => {
    let newError = { ...error };
    let returnFlag = false;
    if (type === 'add' || type === 'modify') {
      if (!!newParams['grpName']) {
        if (newParams['grpName'].length > 50) {
          newError = {
            ...newError,
            grpName: {
              flag: true,
              message: t('그룹명은 50글자로 제한됩니다.'),
            },
          };
        } else {
          newError = {
            ...newError,
            grpName: { flag: false, message: null },
          };
        }
      } else {
        newError = {
          ...newError,
          grpName: { flag: true, message: t('필수값을 입력해주세요.') },
        };
      }
      if (!!newParams['grpSortNo']) {
        if (!onlyNumberRegexp.test(newParams['grpSortNo'])) {
          newError = {
            ...newError,
            grpSortNo: {
              flag: true,
              message: t('우선순위는 숫자만 입력 가능합니다.'),
            },
          };
        } else {
          newError = {
            ...newError,
            grpSortNo: { flag: false, message: null },
          };
        }
      } else {
        newError = {
          ...newError,
          grpSortNo: { flag: true, message: t('필수값을 입력해주세요.') },
        };
      }
      returnFlag = newError['grpName']['flag'] || newError['grpSortNo']['flag'];
    } else if (type === 'addUser') {
      if (!!newParams['userIds']) {
        newError = {
          ...newError,
          userIds: { flag: false, message: null },
        };
      } else {
        newError = {
          ...newError,
          userIds: {
            flag: true,
            message: t('필수값을 입력해주세요.'),
          },
        };
      }
      returnFlag = newError['userIds']['flag'];
    }
    setError(newError);
    return returnFlag;
  };

  const handleModalSubmit = () => {
    if (!handleValidation(modal['params'])) {
      handleSubmit();
    }
  };

  return (
    <Modal
      open={modal.open}
      headerTitle={modal.data.headerTitle}
      handleClose={handleModalClose}
      confirmBtnTitle={modal.data.confirmBtnTitle}
      confirmOnClick={
        modal.type !== 'delete' && modal.type !== 'userDelete'
          ? handleModalSubmit
          : handleSubmit
      }
      useForm={type !== 'delete' && type !== 'userDelete'}
    >
      {type === 'modify' && (
        <tr>
          <th>{t('그룹번호')}</th>
          <td>
            <NewInput
              type="tableInput"
              name="grpNo"
              params={modal.params}
              value={modal.params['grpNo']}
              callBack={handleGetParams}
              disabled
            />
          </td>
        </tr>
      )}
      {(type === 'add' || type === 'modify' || type === 'addUser') && (
        <tr>
          <th>* {t('그룹명')}</th>
          <td>
            <NewInput
              type="tableInput"
              name="grpName"
              params={modal.params}
              value={modal.params['grpName']}
              callBack={handleGetParams}
              disabled={type === 'addUser'}
              error={error.grpName.flag}
              helperText={error.grpName.message}
            />
          </td>
        </tr>
      )}
      {(type === 'add' || type === 'modify') && (
        <tr>
          <th>* {t('우선순위')}</th>
          <td>
            <NewInput
              type="tableInput"
              name="grpSortNo"
              params={modal.params}
              value={modal.params['grpSortNo']}
              callBack={handleGetParams}
              error={error.grpSortNo.flag}
              helperText={error.grpSortNo.message}
            />
          </td>
        </tr>
      )}
      {type === 'addUser' && (
        <tr>
          <th>* {t('사용자ID')}</th>
          <td>
            <NewInput
              type="tableInput"
              name="userIds"
              params={modal.params}
              value={modal.params['userIds']}
              callBack={handleGetParams}
              multiline
              rows={3}
              placeholder="유저 아이디, 유저 아이디, 유저 아이디"
              error={error.userIds.flag}
              helperText={error.userIds.message}
            />
          </td>
        </tr>
      )}
      {type === 'delete' && groupName + t('를(을) 삭제하시겠습니까?')}
      {type === 'userDelete' && t('유저 권한을 삭제하시겠습니까?')}
    </Modal>
  );
};

export default GroupModal;
